// extracted by mini-css-extract-plugin
export default {"root":"NodePanel_root__zKZ5t","content":"NodePanel_content__cnhlX"};